import React, {Fragment, Component} from "react"
import PropTypes from "prop-types"

import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"

import SendExampleSurvey from "./SendExampleSurvey"

class SendExampleSurveyContainer extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired
  }

  handleClick = () => {
    if (this.sendExampleSurvey) {
      this.sendExampleSurvey.handleAction()
    }
  }

  render() {
    const {schedule} = this.props

    return (
      <Fragment>
        <Button onClick={this.handleClick}>
          <FormattedMessage id="insights.schedule.sendExampleSurvey.button.label" />
        </Button>
        <SendExampleSurvey ref={(sendExampleSurvey) => { this.sendExampleSurvey = sendExampleSurvey }} scheduleId={schedule.id} />
      </Fragment>
    )
  }
}


export default SendExampleSurveyContainer
